import request from '../utils/request'

/**
 * 步骤模板相关API
 */

// 获取全局模板列表
export function getTemplateList(params) {
  return request({
    url: '/step-template/list/global',
    method: 'get',
    params
  })
}

// 获取项目模板列表
export function getProjectTemplateList(projectId, params) {
  return request({
    url: `/step-template/list/project/${projectId}`,
    method: 'get',
    params
  })
}

// 获取模板详情和步骤列表
export function getTemplateDetail(templateId) {
  return request({
    url: `/step-template/${templateId}`,
    method: 'get'
  })
}

// 搜索模板
export function searchTemplates(params) {
  return request({
    url: '/step-template/search',
    method: 'get',
    params
  })
}

// 创建步骤模板
export function createTemplate(data) {
  return request({
    url: '/step-template',
    method: 'post',
    data
  })
}

// 更新步骤模板
export function updateTemplate(templateId, data) {
  return request({
    url: `/step-template/${templateId}`,
    method: 'put',
    data
  })
}

// 删除步骤模板
export function deleteTemplate(templateId) {
  return request({
    url: `/step-template/${templateId}`,
    method: 'delete'
  })
}

// 变更模板状态（启用/禁用）
export function changeTemplateStatus(templateId, data) {
  return request({
    url: `/step-template/${templateId}/status`,
    method: 'post',
    data
  })
}

// 获取步骤定义详情
export function getStepDetail(stepId) {
  return request({
    url: `/step-template/step/${stepId}`,
    method: 'get'
  })
}

// 创建步骤定义
export function createStep(data) {
  return request({
    url: '/step-template/step',
    method: 'post',
    data
  })
}

// 更新步骤定义
export function updateStep(stepId, data) {
  return request({
    url: `/step-template/step/${stepId}`,
    method: 'put',
    data
  })
}

// 删除步骤定义
export function deleteStep(stepId) {
  return request({
    url: `/step-template/step/${stepId}`,
    method: 'delete'
  })
}

export default {
  getTemplateList,
  getProjectTemplateList,
  getTemplateDetail,
  searchTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  changeTemplateStatus,
  getStepDetail,
  createStep,
  updateStep,
  deleteStep
}
